import { useEffect, type FC } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { artistsActions } from '@maestra/core/store/slices/artists';
import { useAppDispatch, useAppSelector } from '@maestra/core/store/store';
import type { LockedFeatureKey } from '@maestra/core/constants/bloqueios';
import { ModuloTravadoLigado } from '../ui-carbon/telas/dinheiro/Ligadas';
import { MODULO_DO_BLOQUEIO, membroSemAcesso } from '../logica/casca/acessoDosModulos';
import { CarregandoPagina } from '../ui-carbon/padroes/Carregando';

// O PORTÃO DO ACESSO POR MÓDULO nas telas que não passam pelo `RequireArtistActive` (as do
// Desenvolvimento, livres para o dono de propósito). Só o convidado sem acesso para aqui: ele vê o
// aviso de quem libera, com a casca e o menu em volta. O resto segue direto.
//
// ⚠️ ESPERA A LISTA DE PERFIS (QA do Perfil, 04/10/2026). Sem ela não se sabe quem é convidado: pelo
// endereço direto, a tela abria e lia o que podia antes de o aviso entrar. Enquanto a lista não
// chega, o esqueleto; e é daqui que ela é pedida, porque a tela, que a pediria, ainda não montou
// (como no `RequireArtistActive`).

export const RequireModuloLiberado: FC<{ feature: LockedFeatureKey }> = ({ feature }) => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const user = useAppSelector((s) => s.auth.user);
  const artist = useAppSelector((s) => s.artists.items.find((a) => a.id === id));
  const loaded = useAppSelector((s) => s.artists.loaded);
  const loading = useAppSelector((s) => s.artists.loading);
  useEffect(() => {
    if (user?.id && !loaded && !loading) dispatch(artistsActions.fetchArtists(user.id));
  }, [user?.id, loaded, loading, dispatch]);
  if (!loaded) return <CarregandoPagina />;
  if (artist && membroSemAcesso(artist, MODULO_DO_BLOQUEIO[feature])) {
    return <ModuloTravadoLigado feature={feature} papel='sem-acesso' />;
  }
  return <Outlet />;
};

export default RequireModuloLiberado;
